import { APP_INFO } from '@ricoh/ria.client.core/constants/core/app';
import { newStaticId } from '@ricoh/ria.client.core/utils/data/key';

/** Invalid key for error mapping. */
export const INVALID_KEY = newStaticId(APP_INFO.ID, 'invalidKey');

/** Grid expand field. */
export const GRID_EXPAND_FIELD = newStaticId(APP_INFO.ID, 'gridExpandField');

/** Grid select field. */
export const GRID_SELECT_FIELD = newStaticId(APP_INFO.ID, 'gridSelectField');

/** Form FieldArray key. */
export const FORM_FIELD_ARRAY_KEY = newStaticId(APP_INFO.ID, 'formFieldArrayKey');

/** Form field select all. */
export const FORM_FIELD_SELECT_ALL = newStaticId(APP_INFO.ID, 'formFieldSelectAll');

/** Form DataItem Group. */
export const FORM_DATA_ITEM_GROUP = newStaticId(APP_INFO.ID, 'formDataItemGroup');
